import styled from 'styled-components';

const HorizontalDivider = styled.hr`
  width: 0.1px;
  height: 34px;
  border: solid 1px ${props => props.theme.white4};
`;

export default HorizontalDivider;
